module.exports = __webpack_public_path__ + "static/assets/c46232e8ad99f783710e0010ecd208c3.png";